import SkillCard from "./SkillCard";
import REACT_ICON from "../../icons/icons8-react-native.svg";
import REDUX_ICON from "../../icons/icons8-redux.svg";
import TAILWIND_ICON from "../../icons/tailwind.svg";
import JEST_ICON from "../../icons/jest.svg";
import HTML_ICON from "../../icons/html5-without-wordmark-color-seeklogo.svg";
import CSS_ICON from "../../icons/icons8-css.svg";
import JS_ICON from "../../icons/icons8-javascript.svg";
import JAVA_ICON from "../../icons/java.svg";
import FIREBASE_ICON from "../../icons/firebase.svg";
import PARCEL_ICON from "../../icons/parcel-seeklogo.svg";
import RADIX_ICON from "../../icons/radix-ui-seeklogo.svg";
import GITHUB_ICON from "../../icons/github.svg";
import VSCODE_ICON from "../../icons/icons8-visual-studio-code.svg";
import VERCEL_ICON from "../../icons/vercel.svg";
import EXPRESS_ICON from "../../icons/icons8-express-js.svg";
const skillData = [
  {
    name: "ReactJS",
    // imageLink:"https://img.icons8.com/color/48/react-native.png",
    imageLink: REACT_ICON,
    alt: "react",
  },
  {
    name: "Redux",
    // imageLink:"https://img.icons8.com/color/48/redux.png",
    imageLink: REDUX_ICON,
    alt: "redux",
  },
  {
    name: "HTML",
    // imageLink:"https://img.icons8.com/color/48/html-5--v1.png" ,
    imageLink: HTML_ICON,
    alt: "html",
  },
  {
    name: "CSS",
    // imageLink:"https://img.icons8.com/color/48/css3.png" ,

    imageLink: CSS_ICON,
    alt: "css",
  },
  {
    name: "JavaScript",
    imageLink: "https://img.icons8.com/color/48/javascript--v1.png",
    imageLink: JS_ICON,
    alt: "javascript",
  },
  {
    name: "Java",
    // imageLink:"https://img.icons8.com/color/48/java-coffee-cup-logo--v1.png",
    imageLink: JAVA_ICON,
    alt: "java",
  },
  {
    name: "Express",
    // imageLink:"https://img.icons8.com/color/48/java-coffee-cup-logo--v1.png",
    imageLink: EXPRESS_ICON,
    alt: "express",
  },
  {
    name: "Firebase",
    // imageLink:"https://img.icons8.com/color/48/google-firebase-console.png",
    imageLink: FIREBASE_ICON,
    alt: "firebase",
  },
  {
    name: "TailwindCSS",
    // imageLink:"https://img.icons8.com/color/48/tailwindcss.png" ,
    imageLink: TAILWIND_ICON,
    alt: "tailwind-css",
  },
  {
    name: "Jest",
    // imageLink:"https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/external-jest-can-collect-code-coverage-information-from-entire-projects-logo-color-tal-revivo.png",
    imageLink: JEST_ICON,
    alt: "jest",
  },
  {
    name: "Parcel",
    // imageLink:"https://img.icons8.com/color/48/google-firebase-console.png",
    imageLink: PARCEL_ICON,
    alt: "parcel",
  },
  {
    name: "RadixUI",
    imageLink: RADIX_ICON,
    alt: "radix-ui",
  },
  {
    name: "GitHub",
    // imageLink:"https://img.icons8.com/color/48/github--v1.png",
    imageLink: GITHUB_ICON,
    alt: "github",
  },
  {
    name: "VScode",
    // imageLink:"https://img.icons8.com/color/48/visual-studio-code-2019.png" ,
    imageLink: VSCODE_ICON,
    alt: "vscode",
  },
  {
    name: "Vercel",
    // imageLink:"https://ez-snippet.vercel.app/favicon.ico",
    imageLink: VERCEL_ICON,
    alt: "vercel",
  },
];

const Skill = () => {
  // console.log(skillData);

  return (
    <div className="">
      <h2 className="text-3xl mt-10">Skills & Tools</h2>
      <div className="border-t-2 w-[14%] border-solid border-neutral-400  h-2  mb-10 "></div>
      <p className=" text-xl px-5">
        I possess a range of skills that I've acquired to build my projects,
        along with proficiency in utilizing various tools and technologies.
      </p>

      <div className="skill my-5 flex flex-wrap justify-center">
        {skillData.map((skill) => (
          <SkillCard skill={skill} key={skill.name} />
        ))}
      </div>
    </div>
  );
};

export default Skill;
